module.exports = __webpack_public_path__ + "static/FL0-83a7cc948ee3e35b058923fe73098c60.png";